import React from "react";
import { Route, Switch } from "react-router-dom";
import "./index.css";
import "./styles/toolbar-icons.css";
import ResultComponent from "./components/ResultComponent/ResultComponent";
import MileGrid from "./components/Milegrid";
import Dashboard from "./components/Dashboard";

function App() {

  return (
    <div className="App">
      <Switch>
        <Route path="/" exact>
          <Dashboard />
        </Route>
        <Route exact path="/milegrid/:id">
          <MileGrid isExternal={false} />
        </Route>
        <Route exact path="/milegrid/external/:id">
          <MileGrid isExternal={true} />
        </Route>
        <Route exact path="/template/:id">
          <MileGrid isTemplateDocument={true} />
        </Route>
        <Route exact path="/invalid-document">
          <ResultComponent title="Document Verification Failed , Invalid Document. " />
        </Route>
        <Route path="/unauthorized">
          <ResultComponent title="Security Veification Failed , Unauthorized Access." subTitle="If you believe you should have access to this document please logout and login again. Incase the issues persists please contact the document owner." />
        </Route>
        <Route path="/no-internet">
          <ResultComponent title="No Internet, Check your internet connection." />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
